<template>
    <DocsKycForm v-if="sender_id"
        :sender_id="sender_id"
        :first_name="sender.first_name || ''"
        :last_name="sender.last_name || ''"
        :middle_name="sender.middle_name || ''"
        :email="sender.email || ''"
        :phone="sender.phone || ''"
        :kyc="sender.kyc || {}"
        :files="sender.files || []"
        />
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import CameraForm from '@/components/personal/verification/camera_form.vue'
import DocsKycForm from '@/components/personal/verification/docs_kyc_form.vue'
import { useRoute } from 'vue-router'

export default {
    name: 'SenderEdit',
    data() {
        return {
            sender_id: null,
            sender: {}
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        screen_size() { return this.$store.getters.StateScreenSize },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        
        userPhone: function () { return this.$store.getters.StateUserPhone },
        userPrefix: function () { return this.$store.getters.StateUserPrefix },
        userPhoneNumber() { 
            if(!this.userPhone || !this.userPrefix) return null
            return `${this.userPrefix}${this.userPhone}` 
        },
        userEmail() { return this.$store.getters.StateUserEmail },
        userName() { return this.$store.getters.StateUserName },
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 1000 });
        },
        async GetSender(){
            try {
                const resSender = await this.connect.GetPersonalSenderById(this.sender_id).then(res => res)
                if (resSender.result) {
                    this.sender = {
                        id: resSender.data.id,
                        first_name: resSender.data.first_name,
                        last_name: resSender.data.last_name,
                        middle_name: resSender.data.middle_name,
                        email: resSender.data.email,
                        phone: resSender.data.phone,
                        kyc: resSender.data.kyc,
                        files: resSender.data.files || []
                    }
                } else {
                    this.showMess('error', 'Error', resSender.message || 'Failed to get sender data')
                }
            } catch(e){
                this.showMess('error', 'Error', e.message)
            }
        },
    },
    components: {
        CameraForm,
        DocsKycForm
    },
    beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)
        const route = useRoute()

        // получаем id трансфера
        if(route.params.id!='' && this.helper.is_id(route.params.id)) {
            this.sender_id = route.params.id
            this.GetSender()
        }
        if(!this.sender_id) this.$router.push({ name: 'Not found' })
    }
}
</script>